/** @file localSetting: a JSON value in localStorage that never throws (private mode, blocked storage). */

/** Read and write one key; `load` returns `fallback` when the value is missing, unreadable or storage is blocked. */
export type LocalSetting<T> = { load: () => T; save: (value: T | null) => void };

/** A setting under `key`; `save(null)` removes it. */
export function localSetting<T>(key: string, fallback: T): LocalSetting<T> {
  return {
    load: () => {
      try {
        const raw = globalThis.localStorage.getItem(key);
        return raw === null ? fallback : (JSON.parse(raw) as T);
      } catch {
        return fallback;
      }
    },
    save: (value) => {
      try {
        if (value === null) globalThis.localStorage.removeItem(key);
        else globalThis.localStorage.setItem(key, JSON.stringify(value));
      } catch {
        // Storage blocked: the setting lasts for this page only.
      }
    },
  };
}
